export const getSupportedCategoryCountry = (country: string) => {
  const SUPPORTED_CATEGORY_COUNTRIES = [
    'AU',
    'HK',
    'ID',
    'MY',
    'NZ',
    'PH',
    'SG',
    'TH',
  ];
  return SUPPORTED_CATEGORY_COUNTRIES.includes(country.toUpperCase())
    ? country
    : 'au';
};
